/**
 * useDeviations — list deviations for an organization (read-only from UI).
 */

import { useState, useEffect, useCallback } from 'react';
import { deviationService } from '../services/deviationService';

const DEFAULT_FILTERS = {
  status: 'all',
  severity: 'all',
  isRecurring: false
};

export function useDeviations(organizationId) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState(() => ({ ...DEFAULT_FILTERS }));

  const fetch = useCallback(async () => {
    if (!organizationId) {
      setItems([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const list = await deviationService.getDeviationsByOrganization(organizationId, {
        status: filters.status,
        severity: filters.severity,
        isRecurring: filters.isRecurring ? true : undefined
      });
      setItems(list);
    } catch (err) {
      console.error('[useDeviations] fetch failed:', err);
      setError(err);
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [organizationId, JSON.stringify(filters)]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return {
    items,
    loading,
    error,
    filters,
    setFilters,
    refetch: fetch
  };
}
